import GlobalFilterComponent from '../../../../components/GlobalFilterComponent';
const columns = [
  { field: 'name', Text: 'name' },
  { field: 'description', Text: 'description' },
  { field: 'alias', Text: 'alias' },
];
const TradePlannerNoteType = () => {
  return (
    <div className='main-content-order-request'>
      <GlobalFilterComponent
        columns={columns}
        query={'tradeplanner$type'}
      />
    </div>
  );
};

export default TradePlannerNoteType;
